import { useCookies } from 'react-cookie';
import { Link, useLocation } from 'react-router-dom';
import { appConfig } from '../../config';
import { useTranslation } from 'react-i18next';
import { LiaLanguageSolid } from 'react-icons/lia';

import './leftNav.scss'

function LeftNav() {
  const { i18n } = useTranslation()
  const [cookies, setCookie] = useCookies(['themen'])
  const location = useLocation();

  const changeTheme = () => {
    const htmlElement = document.getElementById('theme')?.classList
    let theme = 'dark'
    htmlElement?.forEach(element => {
      if(element === 'dark') {
        theme = 'dark'
      } else if(element === 'light') {
        theme = 'light'
      }
    })

    if(theme === 'dark') {
      htmlElement?.add('light')
      htmlElement?.remove('dark')
      setCookie('themen', 'light')
    } else {
      htmlElement?.add('dark')
      htmlElement?.remove('light')
      setCookie('themen', 'dark')
    }
  }

  const switchLang = () => {
    const lang =  i18n.language
    i18n.changeLanguage(lang === 'en' ? 'de' : 'en')
  }

  return (
    <div className='comp-leftNav'>

      <div className='leftNav-container'>
        {appConfig.filter(conf => conf.showInNav !== false).map((conf, index) => {
          return (
           <div key={conf.title + conf.path}>
             <Link to={conf.path}>
              <button className={location.pathname === conf.path ? 'btn-active' : ''}>{conf.icon}</button>
            </Link>
           </div>
          )
        })}
      </div>

      <div>
        <div className='leftNav-container leftNav-containerBottom'>
          <button onClick={changeTheme} title='Dark/Light Mode'>
            <svg width='30' height='30' style={cookies.themen === 'light' || cookies.themen === undefined ? {} : { display: 'none' }}>
              <circle cx='15' cy='15' r='6' fill='currentColor' />
              <line
                id='ray'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                x1='15'
                y1='1'
                x2='15'
                y2='4'
              ></line>
              <use href='#ray' transform='rotate(45 15 15)' />
              <use href='#ray' transform='rotate(90 15 15)' />
              <use href='#ray' transform='rotate(135 15 15)' />
              <use href='#ray' transform='rotate(180 15 15)' />
              <use href='#ray' transform='rotate(225 15 15)' />
              <use href='#ray' transform='rotate(270 15 15)' />
              <use href='#ray' transform='rotate(315 15 15)' />
            </svg>

            <svg height="24" width="24" viewBox="0 0 47.539 47.539" style={cookies.themen === 'dark' ? {} : { display: 'none' }}>
              <path fill='currentColor' d="M24.997,47.511C11.214,47.511,0,36.298,0,22.515C0,12.969,5.314,4.392,13.869,0.132 c0.385-0.191,0.848-0.117,1.151,0.186s0.381,0.766,0.192,1.15C13.651,4.64,12.86,8.05,12.86,11.601 c0,12.681,10.316,22.997,22.997,22.997c3.59,0,7.033-0.809,10.236-2.403c0.386-0.191,0.848-0.117,1.151,0.186 c0.304,0.303,0.381,0.766,0.192,1.15C43.196,42.153,34.597,47.511,24.997,47.511z M12.248,3.372C5.862,7.608,2,14.709,2,22.515 c0,12.68,10.316,22.996,22.997,22.996c7.854,0,14.981-3.898,19.207-10.343c-2.668,0.95-5.464,1.43-8.346,1.43 c-13.783,0-24.997-11.214-24.997-24.997C10.861,8.761,11.327,6.005,12.248,3.372z">
              </path> 
            </svg>

          </button>
          <button onClick={switchLang} title='Language'>
            <LiaLanguageSolid />
          </button>
        </div>
        <div className='unknown-identity'>{i18n.language}</div>
      </div>

    </div>
  )
}

export default LeftNav;
